import axios from "axios";
import { useDispatch } from "react-redux";
import { fetchOdczyty } from "../../../Redux/Actions";

const WodaGrupowePodsumowanie = props => {

    const { tablica, daty, setDaty, wybranaWspolnota, czyWybranaWspolnota } = props;   
    
    // console.log(wybranaWspolnota);
    // console.log(czyWybranaWspolnota)

    const dispatch = useDispatch();

    const zimnaSuma = tablica?.reduce( (acc, obj) => { return obj?.czy_wybrany ? acc + (parseFloat(obj.zimna_zuzycie) || 0) : acc }, 0);
    const cieplaSuma = tablica?.reduce( (acc, obj) => { return obj?.czy_wybrany ? acc + (parseFloat(obj.ciepla_zuzycie) || 0) : acc }, 0);
    const ileNowych = tablica?.filter( t => t?.czy_wybrany && !t?.czy_aktualizacja )?.length;
    const ileAktualizacji = tablica?.filter( t => t?.czy_wybrany && t?.czy_aktualizacja )?.length;

    const handleDataOd = e => setDaty( prevState => ({...prevState, dataOd: e.target.value}));
    const handleDataDo = e => setDaty( prevState => ({...prevState, dataDo: e.target.value}));

    const handleSave = async () => {
        try {
            for (const element of tablica) {
                if (element.czy_wybrany) {
                    if (element.czy_aktualizacja) {
                        await axios.post("/api/odczyt/edytuj", {
                            okres_poczatek: daty.dataOd, 
                            okres_koniec: daty.dataDo,
                            ciepla_stan_poczatek: element.ciepla_poczatek,
                            ciepla_stan_koniec: element.ciepla_koniec,
                            zimna_stan_poczatek: element.zimna_poczatek,
                            zimna_stan_koniec: element.zimna_koniec,
                            id: element.id_odczytu,
                            czy_wybrany: element.czy_wybrany
                        });
                    } else {
                        await axios.post("/api/odczyt/dodaj", {
                            id_wspolnoty: wybranaWspolnota.id,
                            id_user: element.id_user,
                            grupa_numer: element.grupa_numer,
                            okres_poczatek: daty.dataOd,
                            okres_koniec: daty.dataDo,
                            ciepla_stan_poczatek: element.ciepla_poczatek,
                            ciepla_stan_koniec: element.ciepla_koniec,
                            ciepla_zuzycie: null,
                            zimna_stan_poczatek: element.zimna_poczatek,
                            zimna_stan_koniec: element.zimna_koniec,
                            zimna_zuzycie: null,
                            czy_wybrany: element.czy_wybrany
                        });
                    }
                }
            }
            dispatch(fetchOdczyty(wybranaWspolnota.id))
        } catch (error) {
            console.error('Błąd podczas dodawania danych:', error);
        }
    }

    return (
        <div className="woda-podsumowanie">
            <div className="table-container">
                <ul className="lista">
                    <li>
                        <span>
                            {`Zaznaczonych mieszkańców: ${tablica?.filter( t => t?.czy_wybrany)?.length } / ${tablica?.length }`}
                        </span>
                    </li>
                    <li>
                        <label htmlFor="p">
                            Początek:
                        </label>
                        <input 
                            type="date"    
                            id="p"
                            value={daty.dataOd}
                            onChange={handleDataOd}
                            disabled={!czyWybranaWspolnota} 
                        />
                    </li>
                    <li>
                        <label htmlFor="p">
                            Koniec:
                        </label>
                        <input 
                            type="date"    
                            id="p"
                            value={daty.dataDo}
                            onChange={handleDataDo}
                            disabled={!czyWybranaWspolnota} 
                        />
                    </li>
                    <li>
                        <span>
                            {`Zużycie wody zimnej: ${zimnaSuma} m³`}
                        </span>
                    </li>
                    <li>
                        <span>
                            {`Zużycie wody ciepłej: ${cieplaSuma} m³`}
                        </span>
                    </li>
                    <li>
                        <span>
                            {`Zużycie razem: ${zimnaSuma + cieplaSuma} m³`}
                        </span> 
                    </li>
                    <li>
                        <span>
                            {`Nowe odczyty: ${ileNowych}`}
                        </span> 
                    </li>
                    <li>
                        <span>
                            {`Zaktualizowane odczyty: ${ileAktualizacji}`}
                        </span> 
                    </li>
                </ul>
                <div className="buttons">
                    <button 
                        onClick={handleSave}
                        disabled={!czyWybranaWspolnota}
                    >
                        Zapisz
                    </button>
                </div>
            </div>
            
        </div>
    )
}

export default WodaGrupowePodsumowanie;